import { Link } from 'react-router-dom';

export function RetrainBanner({ categoryId, categoryName }: { categoryId: number | undefined; categoryName: string | undefined }) {
  return (
    <div className="mb-6 flex items-center justify-between gap-4 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm dark:border-amber-700 dark:bg-amber-950/40">
      <span className="text-amber-800 dark:text-amber-200">
        Training set changed. Retrain {categoryName ?? 'the category'} to rebuild its clusters.
      </span>
      {categoryId != null && (
        <Link
          to={`/categories/${categoryId}`}
          className="shrink-0 font-medium text-amber-900 underline hover:text-amber-700 dark:text-amber-100"
        >
          Open category to retrain →
        </Link>
      )}
    </div>
  );
}
